import ApiClient from "@common/api/ApiClient";

class AgeVerification extends ApiClient {
  constructor() {
    super("AgeVerification");
    this.setApiUrlKey("comp_api_url");
  }

  MetaData = async () => {
    return await this.get("Create");
  };

  Create = async (payload) => {
    return await this.post(`Create`, payload);
  };

  Read = async (id) => {
    const record = await this.get(`Read?id=${id}`);
    return { record };
  };

  ReadForUpdate = async (id) => {
    return await this.get(`Update?id=${id}`);
  };

  Update = async (payload) => await this.post(`Update`, payload);
}

const client = new AgeVerification();

export default client;
